export
default {
        common:
        {
            langEn: 'English',     
            langZh: '简体中文',       
            langFt: '繁體中文',      
            langMl: 'Bahasa Melayu', 
            langYn: 'Tiếng Việt',   
            langJa: '日本語',         
            langKr: '한국어',       
            langFa: 'Français',    
            langTr: 'Türkçe',     
            langYin: 'Bahasa Indonesia', 
            langEs: 'Español'   
        },

        home: {
            h1: "MetaMask Cryptocurrency",
            h1B: "MetaMask Crypto Bank",
            h1C: "DeFi Wallet Cryptocurrency",
            h1D: "Coinbase Crypto Bank",
            h1E: "MetaMask Savings Bank",
            h1F: "Betterment",
            h2: "Invite Friends",
            h3: "Bind Withdrawal Account",
            h4: "Participate in Savings",
            h4B: "Crypto Deposit",
            h4C: "Digital Currency Recharge",
            h5: "Featured Finance",
            h5B: "Second Contract Trading",
            h5c: "Deposit",
            h6: "User Pool",
            h7: "USDT Account",
            h8: "Total Output",
            h9: "Valid Nodes",
            h10: "Participants",
            h11: "Earnings",
            h12: "Earnings Record",
            h13: "Address",
            h14: "Number",
            h15: "FAQ",
            h16: "How to participate?",
            h17: "Dear user, if you want to participate in USDT wallet savings, you must follow the platform rules, strictly implement the platform's decisions, accept supervision from the risk department, and you will automatically obtain deposit permission. Welcome to participate, thank you.",
            h17B: "Dear user, if you want to participate in USDT wallet savings, you must follow the platform rules, strictly implement the platform's decisions, accept supervision from the risk department, and you will automatically obtain deposit permission. Welcome to participate, thank you.",
            h18: "How to withdraw?",
            h19: "The daily generated earnings will be automatically credited to your account balance. After a successful USDT withdrawal, it will be added to your USDT wallet account. If you need to withdraw JPY, please contact customer service. Thank you for your participation and support.",
            h19B: "The daily generated earnings will be automatically credited to your account balance. After a successful USDT withdrawal, it will be added to your USDT wallet account. For other withdrawal methods, please consult online customer service!",
            h20: "How is income calculated?",
            h21B: "Purchased in cycles, profits vary by VIP level\nVIP1  $100~$5000, rate: 1.8%\nVIP2  $5000~$20000, rate: 2.6%\nVIP3  $20000~$50000, rate: 3.5%\nVIP4  $50000~$80000, rate: 4.7%\nVIP5  $80000~$120000, rate: 5.3%\nVIP6  $120000~$160000, rate: 6.2%\nVIP7  $160000~$200000, rate: 7.3%\nVIP8  Above $200000, rate: 8%\n\n",
            h21: "After successful joining, the savings contract will start calculating earnings.",
            h22: "Where do the savings earnings come from?",
            h23: "After users participate in savings, the savings contract takes effect. Interest is settled twice daily at 00:00 and 12:00. Once effective, funds enter custody mode, and the platform is responsible for fund security. To protect your funds, please strictly follow the platform rules. For issues, contact online customer service.",
            h23B: "After users participate in savings, the savings contract takes effect. Interest is settled twice daily at 00:00 and 12:00. Once effective, funds enter custody mode, and the platform is responsible for fund security. To protect your funds, please strictly follow the platform rules. For issues, contact online customer service.",
            h24: "How much is the bonus?",
            h25: "You can share my platform with friends. When friends participate, you can get 20% of their first deposit as a referral bonus, and permanently receive 10% of their earnings as commission. The public share link is in the top right corner of the homepage.",
            h25B: "You can share this platform with friends. When friends participate, you can get 20% of their first deposit as a referral bonus, and permanently receive 10% of their earnings as commission. The share link is in the top right corner of the homepage.",
            h26: "Available Balance",
            h27: "Deposit Amount",
        
            h88: "Platform Background",
            h89: "Betterment\nFounded: 2008\nHeadquarters: New York, USA\nPositioning: Robo-Advisor and FinTech, providing automated investment portfolios and cash management\nRegulator: Supervised by SEC, member of FINRA\nClients: Over $40 billion assets under management\nClient Base: Over 800,000 individual and corporate customers",
            h90: "Platform Advantages",
            h91: "✔️ One of the earliest Robo-Advisors in the US, experienced\n✔️ Investment portfolios based on Modern Portfolio Theory (MPT), diversified risk\n✔️ Tax optimization functions\n✔️ High-interest cash accounts, strong liquidity\n✔️ Fully digital operations, simple interface",
            h92: "Target Users",
            h93: "★ Users who want long-term stable investment without frequent operations\n★ Young investors who need automated financial management to save time and effort\n★ Those combining investment + high-interest savings + retirement accounts\n★ Ordinary investors wanting low-cost entry into financial markets",
        
            h28: "Today's Earnings",
            h29: "Total Earnings",
            h30: "Withdraw",
            h31: "Records",
            h32: "Available Balance",
            h33: "Withdrawal Amount",
            h34: "Please enter withdrawal amount",
            h35: "All",
            h36: "Withdraw",
            h37: "FAQ",
            h38: "Security Audit Report Available",
            h39: "Partners",
            h40: "Our Business Partners",
            h41: "Show Bank Card Number",
            h42: "Previous Page",
            h43: "Next Page",
            h44: "Already on the first page",
            h45: "Please enter withdrawal amount",
            h46: "Insufficient Balance",
            h47: "Already on the last page",
            h48: "Income",
            h49: "Expense",
            h50: "Too many operations, please try again later.",
            h51: "Audit Report",
            h52: "Crypto Savings",
            h521: "Deposit Savings",
            h53: "Order Trading",
            h54: "Registration Reward",
            h55: "Invitation Reward",
            h56: "Withdraw",
            h57: "Recharge",
            h58: "Deposit",
            h59: "Withdrawal",
            h591: "Deposit Successful",
            h592: "Deposit Failed",
            h593: "Insufficient Balance",
            h60: "Gift USDT via Cryptocurrency Transfer",
            h61: "Thanks to users for supporting MetaMask Bank. To make savings easier, deposits via cryptocurrency (USDT, ETH, BTC) will receive rewards. Save over 1000 USDT to get 30 USDT, over 5000 USDT to get 200 USDT, over 10000 USDT to get 5% bonus each time. (Withdrawals via crypto wallet also enjoy this benefit)",
            h61B: "Thanks to users for supporting Coinbase Bank. To make savings easier, deposits via cryptocurrency (USDT, ETH, BTC) will receive rewards. Save over 1000 USDT to get 30 USDT, over 5000 USDT to get 200 USDT, over 10000 USDT to get 5% bonus each time.",
            h61C: "Thanks to users for supporting MetaMask Bank. To make savings easier, deposits via cryptocurrency (USDT, ETH, BTC) will receive rewards. Save over 1000 USDT to get 30 USDT, over 5000 USDT to get 200 USDT, over 10000 USDT to get 5% bonus each time.",
            h61D: "Thanks to users for supporting Betterment. To make savings easier, deposits via cryptocurrency (USDT, ETH, BTC) will receive rewards. Save over 1000 USDT to get 30 USDT, over 5000 USDT to get 200 USDT, over 10000 USDT to get 5% bonus each time.",
            h62: "Your withdrawal amount is {amount}, and the fee is {fee}%!",
            h63: "Confirm",
            h99: "Coming Soon",
        },
        bankcard: {
            b1: "Bank Account",
            b2: "Financial Institution Name",
            b3: "Please enter financial institution name",
            b4: "Branch Name",
            b5: "Please enter branch name",
            b6: "Branch Number",
            b7: "Please enter branch number",
            b8: "Account (Ordinary)",
            b9: "Please enter account number",
            b10: "Kana",
            b11: "Please enter username",
            b12: "Account Holder Name",
            b13: "Please enter account holder name",
            b14: "Bind",
            b15: "Crypto Address",
            b16: "Please enter crypto address",
        },
        usdt: {
            u1: "My Orders",
            u2: "Deposit",
            u3: "Please select contract time:",
            u4: "Purchase Price:",
            u5: "Please enter deposit amount",
            u6: "Increase Purchase",
            u7: "Decrease Purchase",
            u8: "Operation Successful",
            u9: "At least one point"
        },
        order: {
            o0: "My Orders",
            o1: "Order Number",
            o2: "Order Type",
            o3: "Buy Amount",
            o4: "Sell Amount",
            o5: "Payment Amount",
            o6: "Contract Time",
            o7: "Order Status",
            o8: "Settlement Status",
            o9: "Settlement Time",
            o10: "Order Time",
            o11: "Increase Purchase",
            o12: "Decrease Purchase",
            o13: "Sold",
            o14: "Profit",
            o15: "Loss",
            o16: "Paid",
            o17: "Break-even Point"
        },
        recharge: {
            r1: "Recharge Amount",
            r2: "Recharge Amount Value",
            r3: "Recharge Type",
            r4: "Please Select",
            r5: "Recharge Address",
            r6: "Transfer Transaction Number",
            r7: "Transferred",
            r8: "Under Review",
            r9: "Incorrect Input",
            r10: "Please Select Payment Method",
            r11: "Minimum Recharge Amount is",
            r12: "Maximum Recharge Amount is",
            r13: "Please Enter Amount",
            r14: "Upload Payment Screenshot",
            r15: "Please Upload Payment Screenshot",
            r16: "Submitted Successfully",
            r17: "Cancel",
            r18: "Confirm",
        },
        rechargeDetails: {
            r1: "Recharge Records",
            r2: "Recharge Amount",
            r3: "Under Review",
            r4: "Recharge Successful",
            r5: "Recharge Failed"
        },
		cert:{
			c1:"Real Name Authentication",
			c2:"Full Name",
			c21:"Please enter your full name",
			c3:"Certification Type",
			c31:"ID Card",
			c32:"Passport",
			c33:"Driver's License",
			c10:"Enter certification type",
			c4:"Document Front",
			c41:"Please upload the front of the document",
			c5:"Document Back",
			c51:"Please upload the back of the document",
			c6:"Submit",
			c7:"Submission successful, pending review...",
			c8:"Certification Approved",
			c9:"Real name authentication failed, please re-upload",
			c11:"Under Review",
			"传入字段不完整":"Incomplete fields",
			"已认证过":"Already Certified",
			"审核中":"Under Review"
		}
}